const dollars = num => `$${num / 100}`;
export { dollars };
export default {
  dollars,
};


// WEBPACK FOOTER //
// ./src/filters.js